import { render } from "./Agreements.vue?vue&type=template&id=c9d20366"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__